import { lazy } from 'react';
import { BlockConfigurationPanelController } from '@features/block-configuration-panel';

export const DrawerLayoutComponent = {
  Activity: 'activity',
  BlockConfigurationPanel: 'block_configuration_panel',
  Comments: 'comments',
  CheckValidation: 'check_validation',
  TemplateValidation: 'template_validation',
  PbqaEval: 'pbqa_eval',
  RenewalSummary: 'renewal_summary',
} as const;

export const componentsMap = {
  [DrawerLayoutComponent.Activity]: lazy(() =>
    import('@features/activity').then(({ ActivityController }) => ({ default: ActivityController })),
  ),
  [DrawerLayoutComponent.BlockConfigurationPanel]: BlockConfigurationPanelController,
  [DrawerLayoutComponent.Comments]: lazy(() =>
    import('@features/comments').then(({ CommentsController }) => ({
      default: CommentsController,
    })),
  ),
  [DrawerLayoutComponent.CheckValidation]: lazy(() =>
    import('@features/contract-validation/check-validation-panel').then(({ CheckValidationController }) => ({
      default: CheckValidationController,
    })),
  ),
  [DrawerLayoutComponent.TemplateValidation]: lazy(() =>
    import('@features/template-validation').then(({ TemplateValidationPanelController }) => ({
      default: TemplateValidationPanelController,
    })),
  ),
  [DrawerLayoutComponent.PbqaEval]: lazy(() =>
    import('@features/pbqa-eval').then(({ PbqaEvalController }) => ({
      default: PbqaEvalController,
    })),
  ),
  [DrawerLayoutComponent.RenewalSummary]: lazy(() =>
    import('@features/renewal-summary').then(({ RenewalSummaryController }) => ({
      default: RenewalSummaryController,
    })),
  ),
};
